export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "HEGXIB Nigeria",
  "url": "https://ng.hegxib.me",
  "logo": "https://ng.hegxib.me/assets/HXB-NG-NO-BACKGROUND.png",
  "description": "Leading provider of digital solutions, technology services, web development, mobile apps, and IT consulting in Nigeria.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "Nigeria"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "email": "contact@hegxib.me"
  },
  "sameAs": [
    "https://facebook.com/hegxib",
    "https://twitter.com/hegxib",
    "https://linkedin.com/company/hegxib",
    "https://instagram.com/hegxib"
  ]
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "HEGXIB Nigeria",
  "url": "https://ng.hegxib.me",
  "description": "Leading provider of digital solutions, technology services, web development, mobile apps, and IT consulting in Nigeria.",
  "publisher": {
    "@type": "Organization",
    "name": "HEGXIB Nigeria",
    "logo": {
      "@type": "ImageObject",
      "url": "https://ng.hegxib.me/assets/HXB-NG-NO-BACKGROUND.png"
    }
  }
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Digital Solutions & Technology Services",
  "provider": {
    "@type": "Organization",
    "name": "HEGXIB Nigeria"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Digital Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web Development",
          "description": "Custom websites and web applications built with cutting-edge technology"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Digital Marketing",
          "description": "SEO, social media, and digital advertising strategies"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "IT Consulting",
          "description": "Expert technology consulting and strategic planning"
        }
      }
    ]
  }
};
